<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="物流公司(配送方式)" prop="deliveryCompany">
                <el-select v-model="dataForm.deliveryCompany" placeholder="物流公司(配送方式)">
                    <el-option label="全选" value="" key=""></el-option>
                    <el-option
                            v-for="item in shipCompanyList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="物流单号" prop="deliveryNumber">
                <el-input v-model="dataForm.deliveryNumber" placeholder="物流单号"></el-input>
            </el-form-item>
            <el-form-item label="发货日期" prop="deliveryTimeString">
                <el-date-picker
                        v-model="dataForm.deliveryTimeString"
                        type="datetime" format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择发货日期">
                </el-date-picker>
            </el-form-item>
<!--            <el-form-item v-if="dataForm.equipmenNumber" label="设备编号" prop="equipmenNumber">-->
<!--                <div v-for="(item,index) in dataForm.equipmenNumber" :key="index">-->
<!--                    <input class="input" placeholder="设备编号" :ref="`inputValue`" style="padding-bottom: 7px;padding-top: 7px;padding-left: 15px;height: 40px;width: 271px;"></input>-->
<!--                </div>-->
<!--            </el-form-item>-->
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        data() {
            return {
                visible: false,
                shipCompanyList:[],
                dataForm: {
                    id: '',
                    memberId: '',
//发货参数
                    deliveryCompany: '',
                    deliveryNumber: '',
                    equipmenNumber: [],
                    deliveryTimeString:''
//发货参数
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    deliveryCompany: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    deliveryNumber: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    deliveryTimeString: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getShipCompanyList();
                        this.getInfo()
                    }
                })
            },
            //获取物流公司列表
            getShipCompanyList(){
                this.$http.get(`/oms/order/shipCompanyList`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    /*this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }*/
                    this.shipCompanyList=res.data;
                }).catch(() => {
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/oms/order/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    /*this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }*/
                    this.dataForm.id=res.data.id;
                    this.dataForm.memberId=res.data.memberId
                    this.dataForm.deliveryCompany=res.data.deliveryCompany
                    this.dataForm.deliveryNumber=res.data.deliveryNumber
                    this.dataForm.deliveryTimeString=res.data.deliveryTime;
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                console.log(this.$refs['inputValue'])
                if(this.$refs['inputValue']!=undefined){
                    console.log(this.$refs['inputValue'])
                var length = this.$refs['inputValue'].length
                for(var i=0;i<length;i++){
                    console.log(i)
                    var value =this.$refs['inputValue'][i].value
                    console.log('inputvalue'+value)
                    if(value!=""){
                        this.dataForm.equipmenNumber.push(value)
                    }
                }
                }

                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/oms/order/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            // console.log("111111111")
                            this.getInfo()
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
<style>
    .input{
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;
    }
</style>
